import { minBreakpoints } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { colors, spacing, typography } = themeVariables;

export const imageWrapper = css`
  position: relative;
  margin: 0 auto;
`;

export const image = css`
  display: block;
  width: 100%;
  height: 456px;
  object-fit: cover;
  object-position: center;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      height: 480px;
    `,
  )}
`;

export const heading = css`
  position: absolute;
  left: 0;
  right: 0;
  margin: 0;
  color: var(${colors.content.action});
  z-index: 2;
  line-height: var(${typography.heading.sizes.lg.lineHeight});

  &::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    height: 100%;
    pointer-events: none;
    z-index: -1;
    backdrop-filter: blur(2px);
  }

  span {
    display: block;
  }
`;

export const headingTop = css`
  top: 0;
  padding: var(${spacing.xl}) var(${spacing.xl}) 0;
  &::before {
    top: 0;
    background: linear-gradient(to bottom, #1e1e29 0%, transparent 100%);
  }
`;

export const headingBottom = css`
  bottom: 0;
  padding: 0 var(${spacing.xl}) var(${spacing.xl});
  &::before {
    bottom: 0;
    background: linear-gradient(to top, #1e1e29 0%, transparent 100%);
`;
